import React from "react";

const RoleNode = ({ node }) => {
  return (
    <div className="p-2 border rounded-lg bg-white shadow-md text-center inline-block">
      <h3 className="font-semibold text-blue-600">{node.name}</h3>

        <ul className="mt-1">
        {Array.isArray(node.users) && node.users.length > 0 ? (
          node.users.map((u) => (
            <li key={u.id} className="text-gray-600 text-sm">
              {u.name}
            </li>
          ))
        ) : (
          <li className="text-gray-400 text-sm italic">No employee</li>
        )}
      </ul>

      {node.children && node.children.length > 0 && (
        <div className="mt-4 flex justify-center space-x-4">
          {node.children.map((child) => (
            <RoleNode key={child.id} node={child} />
          ))}
        </div>
      )}
    </div>
  );
};

export default RoleNode;
